import styled from 'styled-components';

export default styled.div`
  position: absolute;
  bottom: -48px;
  z-index: 2;
  width: 100%;
`;
